// @flow
import { Schema } from "../../../components/form";

const formSchema = new Schema({
  name: {
    type: "string",
    required: true
  },
  email: {
    type: "string",
    required: true,
    validator: value => {
      const re = /^[a-zA-Z0-9_.]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;

      if (!re.test(String(value).toLowerCase())) {
        return "E-mail inválido";
      }
    }
  },
  newsSubscriber: {
    type: "boolean"
  },
  emailConfirmation: {
    type: "string",
    required: true,
    validator: (value, allValues) => {
      if (value !== allValues.email) {
        return "O email e sua confirmação devem ser iguais";
      }
    }
  },
  password: {
    type: "string",
    required: true,
    validator: value => {
      if (value.length < 8) {
        return "Senha muito curta";
      }
      let numeros = 0;
      let letras = 0;
      let caracteres = value.split("");
      for (let car of caracteres) {
        if (car.match(/\d/)) numeros++;
        else if (car.match(/\w/)) letras++;
      }
      if (numeros === 0 || letras === 0) {
        return "A sua senha deve conter letras e números";
      }
    }
  },
  passwordConfirmation: {
    type: "string",
    required: true,
    validator: (value, allValues) => {
      if (value !== allValues.password) {
        return "A senha e sua confirmação devem ser iguais";
      }
    }
  },
  terms: {
    type: "boolean",
    required: true
  }
});

export default formSchema;
